<template>
  <div id="app">
    <div class="hdp-header">
      <div class="hdp-logo" @click="onRoute({name: 'HomeView'})">
        <img width="30" height="30" src="./assets/svg/logo.svg">
        <div>{{ $t('helpAndSupport') }}</div>
      </div>
      <div class="hdp-link-contacts" @click="onRoute({name: 'TicketView'})">
        <div>{{ $t('contactUs') }}</div>
        <img width="20" height="20" src="./assets/svg/icon-contacts.svg">
      </div>
    </div>
    <div class="hdp-content">
      <app-router :route="this.route" @route="onRoute" />
    </div>
  </div>
</template>

<script>
import AppRouter from '@/components/Router.vue'

export default {
  name: 'App',

  components: {
    AppRouter
  },

  data () {
    return {
      route: {name: 'HomeView'}
    }
  },

  created () {
    if (!window.tealium) {
      this.addTealium()
    }
  },

  methods: {
    addTealium () {
      window.utag_data = {}
      window.utag_cfg_ovrd = {noview: true}

      const script = document.createElement('script')
      script.src = 'https://st.fxclub.org/main/prod/utag.js'
      script.type = 'text/javascript'
      script.async = true

      const ref = document.getElementsByTagName('script')[0]
      ref.parentNode.insertBefore(script, ref.nextSibling)
    },
    onRoute (route) {
      this.route = route
    }
  }
}
</script>

<style>
  .hdp-view {
    background-color: #242526;
    font-family: 'Roboto', 'Arial', sans-serif;
    color: #fff;
    font-size: 16px;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    overflow-y: scroll;
    height: 100%;
  }
  .hdp-h1 {
    font-weight: 700;
    font-size: 18px;
    margin-bottom: 15px;
  }
  .hdp-h2 {
    font-weight: 700;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .hdp-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    padding: 16px 10px;
    background-color: #3a3b3c;
  }
  .hdp-logo {
    display: flex;
    align-items: center;
  }
  .hdp-logo img {
    margin-right: 8px;
  }
  .hdp-link-contacts {
    display: flex;
    align-items: center;
    font-size: 14px;
  }
  .hdp-link-contacts img {
    margin-left: 8px;
  }
  .hdp-link-contacts div {
    white-space: nowrap;
  }
  .hdp-head {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
  }
  .hdp-head .hdp-h1 {
    margin-bottom: 0;
  }
  .hdp-content {
    padding: 0 10px;
  }
  .hdp-btn {
    -webkit-appearance: none;
    box-sizing: border-box;
    display: inline-block;
    font-size: 16px;
    line-height: 1.5;
    border: none;
    border-radius: .25rem;
    background-color: #7e98e5;
    cursor: pointer;
    color: #ffffff;
    text-align: center;
    text-overflow: ellipsis;
    text-decoration: none;
    padding: .375rem .75rem;
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue